import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';

// Shared tab bar for the payroll allowance pages. `active` is the path of the
// page rendering it, so that tab shows as selected.
const TABS = [
	{ to: '/Addallowance-deduction', label: 'Manage Allowance' },
	{ to: '/Bata', label: 'Bata' },
	{ to: '/Visitor-employee', label: 'Visitor Employee' },
];

const PayrollNav = ({ active }) => (
	<div className="section-body mb-4">
		{TABS.map(tab => (
			<Link key={tab.to} to={tab.to}>
				<button
					type="button"
					className={`btn me-2 ${tab.to === active ? 'btn-primary' : 'btn-light'}`}
				>
					{tab.label}
				</button>
			</Link>
		))}
	</div>
);

export default PayrollNav;
